import React, { useEffect, useState } from "react";

import VatReport from "./VatReport";
import PurchaseReport from "./PurchaseReport";
import SalesReport from "./SalesReport";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { getUserList } from "../../../redux/invoice/action";
import TestingAccountFilter from "../../Common/TestingAccountFilter";

const ReportsList = () => {
  const dispatch = useDispatch();
  const [params, setParams] = useState({
    search_key: "",
    testing_account_filter: "hide",
    // page: 1
  });
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [testingAccountFilter, setTestingAccountFilter] = useState("hide");
  const userList = useSelector((state) => state?.reusableSlice?.userList);

  const proOptions = userList?.users?.map((item) => ({
    value: item?.id,
    label: item?.full_name,
  }));

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    // setSelectedClient("");
  };

  const handleTestingAccountFilterChange = (event) => {
    const value = event.target.value;
    setTestingAccountFilter(value);
    setSelectedOptions(null);
    setParams((prev) => ({
      ...prev,
      testing_account_filter: value,
    }));
  };

  useEffect(() => {
    dispatch(getUserList(params));
  }, [dispatch, params]);

  return (
    <div>
      <div
        className="d-flex align-items-center mt-5"
        style={{ columnGap: "30px" }}
      >
        <h2>Reports</h2>
        <div className="col-md-4">
          {/* <label>User</label> */}
          <ReactSelect
            value={selectedOptions}
            onChange={handleChange}
            options={proOptions}
            placeholder="select customer"
          />
        </div>
        <TestingAccountFilter
          className="col-md-3 form-group mb-0"
          value={testingAccountFilter}
          onChange={handleTestingAccountFilterChange}
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <SalesReport
          selectedOptions={selectedOptions?.value}
          testingAccountFilter={testingAccountFilter}
        ></SalesReport>
      </div>
      <div className="row">
        <div className="col-6" style={{ marginTop: "50px" }}>
          <PurchaseReport
            selectedOptions={selectedOptions?.value}
            testingAccountFilter={testingAccountFilter}
          ></PurchaseReport>
        </div>
        <div className="col-6" style={{ marginTop: "50px" }}>
          <VatReport
            selectedOptions={selectedOptions?.value}
            testingAccountFilter={testingAccountFilter}
          ></VatReport>
        </div>
      </div>
    </div>
  );
};

export default ReportsList;
